<template>
    <div>
        <b-card class="card-accent-info" header="Franquia - Criar Pagamentos (Inscrição e Mensalidades)">
            <b-row>
                <b-col cols="auto">
                    <b-form-group>
                        <label for="user" style="font-size: 0.8em">Usuário</label>
                        <b-form-select id="user"
                            v-model="userId"
                            :plain="true"
                            :options="userDDL"                        
                            :value="[null,'c']">
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="auto">
                  <b-form>
                    <b-form-group>
                        <label for="startDate" style="font-size: 0.8em">Data de Início</label>
                        <b-form-input v-model="startDate" type="date" id="startDate"></b-form-input>
                    </b-form-group>

                  </b-form>
                </b-col>

                <b-col cols="auto">
                  <b-form>
                    <b-form-group>
                        <label for="endDate" style="font-size: 0.8em">Data de Término</label>
                        <b-form-input v-model="endDate" type="date" id="endDate"></b-form-input>
                    </b-form-group>

                  </b-form>
                </b-col>

                <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                    <b-form-group>
                        <p></p>
                        <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="createPayment()" :disabled="creatingPayment"><i class="fa fa-search"></i><span>Criar Pagamentos</span></b-button>
                    </b-form-group>
                </b-col>

            </b-row>
            Permite criar os pagamentos de Inscrição e Mensalidades para os usuário.
            <p></p>
            <span class="text-muted">[GET] /franchise/payment/create?groupUserId=<span class="text-danger">&lt;ID_USUARIO&gt;</span>&startDate=<span class="text-danger">&lt;DATA_INICIAL&gt;</span>&endDate=<span class="text-danger">&lt;DATA_FINAL&gt;</span>&uid=<span class="text-danger">&lt;UID&gt;</span>&sid=<span class="text-danger">&lt;SID&gt;</span></span>
            <br>
            <span class="text-muted">[GET] /franchise/payment/create?groupId=<span class="text-danger">&lt;ID_GRUPO&gt;</span>&userId=<span class="text-danger">&lt;ID_USUARIO&gt;</span>&startDate=<span class="text-danger">&lt;DATA_INICIAL&gt;</span>&endDate=<span class="text-danger">&lt;DATA_FINAL&gt;</span>&uid=<span class="text-danger">&lt;UID&gt;</span>&sid=<span class="text-danger">&lt;SID&gt;</span></span>
        </b-card>
    </div>
</template>

<script>

import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}
  
miniToastr.init({types: toastTypes})
  
function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}
  
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)
  
Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'ActionFinanceAccountMovementReprocess',
    data: () => {
        return {
            creatingPayment: false,
            userDDL: [],
            startDate: null,
            endDate: null,
            userId: 0
        }
    },
    methods: {
        async createPayment() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            var startDateDay = this.startDate ? this.startDate.toString().replaceAll('-','') : ''
            var endDateDay = this.endDate ? this.endDate.toString().replaceAll('-','') : ''

            if(startDateDay.length==8) startDateDay = startDateDay.substr(0,6)
            if(endDateDay.length==8) endDateDay = endDateDay.substr(0,6)

            if(this.userId && this.userId > 0) {
                s.creatingPayment = true
                //console.log(this.$store.state.ws_url + "/franchise/payment/create?groupUserId=" + this.userId + "&startDate=" + startDateDay + "&endDate=" +  endDateDay + "&uid=" + currentUser.id + "&sid=" + currentUser.sid)


                await axios.get(this.$store.state.ws_url + "/franchise/payment/create?groupUserId=" + this.userId + "&startDate=" + startDateDay + "&endDate=" +  endDateDay + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

                ).then(function(resp) {
                    toast ({
                        type: VueNotifications.types.success,
                        title: 'Criar pagamento',
                        message: 'Pagamento criado com sucesso.',
                        timeout: 2000
                    });

                    s.creatingPayment = false
                }).catch(function(error) {
                    toast ({
                        type: VueNotifications.types.error,
                        title: 'Criar pagamento',
                        message: 'Erro ao criar pagamento: ' + error.resp.obj.message,
                        timeout: 2000
                    });

                    s.creatingPayment = false
                })
            }
            else {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Criar pagamento',
                    message: 'Selecione o usuário.',
                    timeout: 2000
                });
            }
        },

        async refreshUserList() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/franchise/group/user/ddl?returnGroupUser=1&companyId=" + currentUser.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.userDDL = resp.data.obj;                  
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },
    },
    mounted: function() {
        var now = new Date()
        this.endDate = this.$utils.dateFormat(now)
        this.refreshUserList()
    }
}

</script>